import React from 'react';
import { Layout, Menu, Button, Space, Typography, Avatar, Dropdown } from 'antd';
import {
    DashboardOutlined, 
    UserOutlined, 
    SettingOutlined, 
    TransactionOutlined,
    LineChartOutlined,
    LogoutOutlined,
    SafetyOutlined,
    BellOutlined,
    GiftOutlined,
    DeploymentUnitOutlined,
    AppstoreOutlined,
    PieChartOutlined,
    AreaChartOutlined,
    HistoryOutlined,
    LayoutOutlined,
    CustomerServiceOutlined,
    RocketOutlined,
    TeamOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useBranding } from '../../hooks/useBranding';

const { Header } = Layout;
const { Text } = Typography;

const AdminHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();
    const { branding } = useBranding();

    const menuItems = [
        { key: '/admin', icon: <DashboardOutlined />, label: 'Dashboard', onClick: () => navigate('/admin') },
        { key: '/admin/stats', icon: <PieChartOutlined />, label: 'Stats', onClick: () => navigate('/admin/stats') },
        { key: '/admin/users', icon: <UserOutlined />, label: 'Users', onClick: () => navigate('/admin/users') },
        { key: '/admin/mlm', icon: <DeploymentUnitOutlined />, label: 'MLM', onClick: () => navigate('/admin/mlm') },
        { key: '/admin/invest', icon: <LineChartOutlined />, label: 'Plans', onClick: () => navigate('/admin/invest') },
        { key: '/admin/invest-types', icon: <AppstoreOutlined />, label: 'Types', onClick: () => navigate('/admin/invest-types') },
        { key: '/admin/bonuses', icon: <GiftOutlined />, label: 'Bonuses', onClick: () => navigate('/admin/bonuses') },
        { key: '/admin/kyc', icon: <SafetyOutlined />, label: 'KYC', onClick: () => navigate('/admin/kyc') },
        { key: '/admin/financial-transactions', icon: <TransactionOutlined />, label: 'Finance', onClick: () => navigate('/admin/financial-transactions') },
        { key: '/admin/market-analyses', icon: <AreaChartOutlined />, label: 'Market', onClick: () => navigate('/admin/market-analyses') },
        { key: '/admin/market-control', icon: <LineChartOutlined />, label: 'Control', onClick: () => navigate('/admin/market-control') },
        { key: '/admin/audit-logs', icon: <HistoryOutlined />, label: 'Audit', onClick: () => navigate('/admin/audit-logs') },
        { key: '/admin/branding', icon: <LayoutOutlined />, label: 'CMS', onClick: () => navigate('/admin/branding') },
        { key: '/admin/notifications', icon: <BellOutlined />, label: 'Notifs', onClick: () => navigate('/admin/notifications') },
        { key: '/admin/crm', icon: <TeamOutlined />, label: 'CRM', onClick: () => navigate('/admin/crm') },
        { key: '/admin/marketing', icon: <RocketOutlined />, label: 'Marketing', onClick: () => navigate('/admin/marketing') },
        { key: '/admin/support', icon: <CustomerServiceOutlined />, label: 'Support', onClick: () => navigate('/admin/support') },
        { key: '/admin/settings', icon: <SettingOutlined />, label: 'System', onClick: () => navigate('/admin/settings') },
    ];

    const userMenuItems = {
        items: [
            {
                key: 'profile',
                icon: <UserOutlined />,
                label: 'Mon Profil',
                onClick: () => navigate('/profile')
            },
            {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: 'Déconnexion',
                onClick: logout
            }
        ]
    };

    return (
        <Header className="admin-header-premium">
            <div className="admin-header-logo" onClick={() => navigate('/admin')}>
                {branding.logo_url ? (
                    <img src={branding.logo_url} alt="Logo" style={{ height: 32, marginRight: 12 }} />
                ) : (
                    <SafetyOutlined className="logo-icon" />
                )}
                <div className="logo-text">
                    <span className="logo-main">{branding.site_name.split(' ')[0]}</span>
                    <span className="logo-sub">ADMIN</span>
                </div>
            </div>

            <Menu
                mode="horizontal"
                selectedKeys={[location.pathname]}
                items={menuItems}
                className="admin-header-menu"
                style={{ flex: 1, minWidth: 0 }}
            />

            <div className="admin-header-actions">
                <Space size="large">
                    <Button type="text" icon={<BellOutlined />} className="action-icon" />
                    
                    <Dropdown menu={userMenuItems} placement="bottomRight" arrow>
                        <Space className="admin-user-profile">
                            <Avatar src={user?.avatar} icon={<UserOutlined />} className="admin-avatar" />
                            <div className="admin-user-info hide-mobile">
                                <Text strong className="admin-username">{user?.username}</Text>
                                <Text className="admin-role">ADMIN HQ</Text>
                            </div>
                        </Space>
                    </Dropdown>
                </Space>
            </div>
        </Header>
    );
};

export default AdminHeader;
